// @flow

export const GetSystemUsers = "GET_SYSTEM_USERS";
export const GetSystemUsersSuccess = "GET_SYSTEM_USERS_SUCCESS";
export const GetSystemUsersError = "GET_SYSTEM_USERS_ERROR";

// Callback Admin
export const GetManagementCallbackQueues = "GET_MANAGEMENT_CALLBACK_QUEUES";
export const GetManagementCallbackQueuesSuccess = "GET_MANAGEMENT_CALLBACK_QUEUES_SUCCESS";
export const GetManagementCallbackQueuesError = "GET_MANAGEMENT_CALLBACK_QUEUES_ERROR";
export const GetActiveManagementCallbacks = "GET_ACTIVE_MANAGEMENT_CALLBACKS";
export const GetActiveManagementCallbacksSuccess = "GET_ACTIVE_MANAGEMENT_CALLBACKS_SUCCESS";
export const GetActiveManagementCallbacksError = "GET_ACTIVE_MANAGEMENT_CALLBACKS_ERROR";
export const GetCompletedManagementCallbacks = "GET_COMPLETED_MANAGEMENT_CALLBACKS";
export const GetCompletedManagementCallbacksSuccess = "GET_COMPLETED_MANAGEMENT_CALLBACKS_SUCCESS";
export const GetCompletedManagementCallbacksError = "GET_COMPLETED_MANAGEMENT_CALLBACKS_ERROR";
export const ToggleRemoveCallbackModal = "TOGGLE_REMOVE_CALLBACK_MODAL";
export const ToggleRescheduleCallbackModal = "TOGGLE_RESCHEDULE_CALLBACK_MODAL";
export const ToggleCreateCallbackModal = "TOGGLE_CREATE_CALLBACK_MODAL";
export const UpdateManagementCallback = "UPDATE_MANAGEMENT_CALLBACK";
export const UpdateManagementCallbackSuccess = "UPDATE_MANAGEMENT_CALLBACK_SUCCESS";
export const UpdateManagementCallbackError = "UPDATE_MANAGEMENT_CALLBACK_ERROR";
export const CallbacksEmployeeSearch = "CALLBACKS_EMPLOYEE_SEARCH";
export const CallbacksEmployeeExtendedSearch = "CALLBACK_EMPLOYEE_EXTENDED_SEARCH";
export const CallbacksEmployeeExtendedSearchSuccess = "CALLBACK_EMPLOYEE_EXTENDED_SEARCH_SUCCESS";
export const CallbacksEmployeeSearchSuccess = "CALLBACKS_EMPLOYEE_SEARCH_SUCCESS";
export const CallbacksEmployeeSearchResetResults = "CALLBACKS_EMPLOYEE_SEARCH_RESET_RESULTS";
export const CallbacksEmployeeSearchError = "CALLBACKS_EMPLOYEE_SEARCH_ERROR";
export const CreateCallback = "CREATE_CALLBACK";
export const CreateCallbackSuccess = "CREATE_CALLBACK_SUCCESS";
export const CreateCallbackError = "CREATE_CALLBACK_ERROR";

// QUEUE MANAGEMENT
export const GetCallbackScheduledWindows = "GET_CALLBACK_SCHEDULED_WINDOWS_REQUEST";
export const GetCallbackScheduledWindowsSuccess = "GET_CALLBACK_SCHEDULED_WINDOWS_SUCCESS";
export const GetCallbackScheduledWindowsError = "GET_CALLBACK_SCHEDULED_WINDOWS_ERROR";
export const ToggleEditCallbackQueueModal = "TOGGLE_EDIT_CALLBACK_QUEUE_MODAL";
export const ChangeEditCallbackQueueModal = "CHANGE_EDIT_CALLBACK_QUEUE_MODAL";
export const BulkChangeEditCallbackQueueModal = "BULK_CHANGE_EDIT_CALLBACK_QUEUE_MODAL";
export const UpdateCallbackScheduledWindows = "UPDATE_CALLBACK_SCHEDULED_WINDOWS_REQUEST";
export const UpdateCallbackScheduledWindowsSuccess = "UPDATE_CALLBACK_SCHEDULED_WINDOWS_SUCCESS";
export const UpdateCallbackScheduledWindowsError = "UPDATE_CALLBACK_SCHEDULED_WINDOWS_ERROR";

export const SetSystemUserStatus = "SET_SYSTEM_USER_STATUS";
export const SetSystemUserStatusSuccess = "SET_SYSTEM_USER_STATUS_SUCCESS";
export const SetSystemUserStatusError = "SET_SYSTEM_USER_STATUS_ERROR";
export const UpdateSystemUser = "UPDATE_SYSTEM_USER";
export const UpdateSystemUserSuccess = "UPDATE_SYSTEM_USER_SUCCESS";
export const UpdateSystemUserError = "UPDATE_SYSTEM_USER_ERROR";
export const SetSystemUsersSort = "SET_SYSTEM_USERS_SORT";
export const OpenAddUserModal = "OPEN_ADD_SYSTEM_USER_MODAL";
export const CloseAddUserModal = "CLOSE_ADD_SYSTEM_USER_MODAL";
export const OpenEditUserModal = "OPEN_EDIT_SYSTEM_USER_MODAL";
export const CloseEditUserModal = "CLOSE_EDIT_SYSTEM_USER_MODAL";
export const SearchEmployees = "MANAGEMENT_SEARCH_EMPLOYEES";
export const SearchEmployeesSuccess = "MANAGEMENT_SEARCH_EMPLOYEES_SUCCESS";
export const SearchEmployeesError = "MANAGEMENT_SEARCH_EMPLOYEES_ERROR";
export const ExportSystemUsers = "MANAGEMENT_EXPORT_SYSTEM_USERS";
export const ExportSystemUsersSuccess = "MANAGEMENT_EXPORT_SYSTEM_USERS_SUCCESS";
export const ExportSystemUsersError = "MANAGEMENT_EXPORT_SYSTEM_USERS_ERROR";

// ADVISORS
export const GetAdvisor = "GET_ADVISOR";
export const GetAdvisorSuccess = "GET_ADVISOR_SUCCESS";
export const GetAdvisorError = "GET_ADVISOR_ERROR";
export const GetAdvisors = "GET_ADVISORS";
export const GetAdvisorsSuccess = "GET_ADVISORS_SUCCESS";
export const GetAdvisorsError = "GET_ADVISORS_ERROR";
export const SetAdvisorsSort = "SET_ADVISORS_SORT";
export const GetAdvisorActivity = "GET_ADVISOR_ACTIVITY";
export const GetAdvisorActivitySuccess = "GET_ADVISOR_ACTIVITY_SUCCESS";
export const GetAdvisorActivityError = "GET_ADVISOR_ACTIVITY_ERROR";
export const ExportAdvisorActivity = "EXPORT_ADVISOR_ACTIVITY";
export const ExportAdvisorActivitySuccess = "EXPORT_ADVISOR_ACTIVITY_SUCCESS";
export const ExportAdvisorActivityError = "EXPORT_ADVISOR_ACTIVITY_ERROR";

// CALLBACK DASHBOARD
export const GetCallbackQueueDashboardHeadlines = "GET_CALLBACK_QUEUE_DASHBOARD_HEADLINES";
export const GetCallbackQueueDashboardHeadlinesSuccess =
  "GET_CALLBACK_QUEUE_DASHBOARD_HEADLINES_SUCCESS";
export const GetCallbackQueueDashboardHeadlinesError =
  "GET_CALLBACK_QUEUE_DASHBOARD_HEADLINES_ERROR";

export const GetCallbackQueueDashboardClientsSummary =
  "GET_CALLBACK_QUEUE_DASHBOARD_CLIENTS_SUMMARY";
export const GetCallbackQueueDashboardClientsSummarySuccess =
  "GET_CALLBACK_QUEUE_DASHBOARD_CLIENTS_SUMMARY_SUCCESS";
export const GetCallbackQueueDashboardClientsSummaryError =
  "GET_CALLBACK_QUEUE_DASHBOARD_CLIENTS_SUMMARY_ERROR";
export const ExportCallbackQueueDashboardClientsSummary =
  "EXPORT_CALLBACK_QUEUE_DASHBOARD_CLIENTS_SUMMARY";
export const ExportCallbackQueueDashboardClientsSummarySuccess =
  "EXPORT_CALLBACK_QUEUE_DASHBOARD_CLIENTS_SUMMARY_SUCCESS";
export const ExportCallbackQueueDashboardClientsSummaryError =
  "EXPORT_CALLBACK_QUEUE_DASHBOARD_CLIENTS_SUMMARY_ERROR";

export const GetCallbackQueueDashboardAdvisorsSummary =
  "GET_CALLBACK_QUEUE_DASHBOARD_ADVISORS_SUMMARY";
export const GetCallbackQueueDashboardAdvisorsSummarySuccess =
  "GET_CALLBACK_QUEUE_DASHBOARD_ADVISORS_SUMMARY_SUCCESS";
export const GetCallbackQueueDashboardAdvisorsSummaryError =
  "GET_CALLBACK_QUEUE_DASHBOARD_ADVISORS_SUMMARY_ERROR";
export const ExportCallbackQueueDashboardAdvisorsSummary =
  "EXPORT_CALLBACK_QUEUE_DASHBOARD_ADVISORS_SUMMARY";
export const ExportCallbackQueueDashboardAdvisorsSummarySuccess =
  "EXPORT_CALLBACK_QUEUE_DASHBOARD_ADVISORS_SUMMARY_SUCCESS";
export const ExportCallbackQueueDashboardAdvisorsSummaryError =
  "EXPORT_CALLBACK_QUEUE_DASHBOARD_ADVISORS_SUMMARY_ERROR";

// CALL SCRIPTS
export const GetCallScripts = "GET_CALL_SCRIPTS";
export const GetCallScriptsSuccess = "GET_CALL_SCRIPTS_SUCCESS";
export const GetCallScriptsError = "GET_CALL_SCRIPTS_ERROR";

export const GetMedicalTriageScripts = "GET_MEDICAL_TRIAGE_SCRIPTS";
export const GetMedicalTriageScriptsSuccess = "GET_MEDICAL_TRIAGE_SCRIPTS_SUCCESS";
export const GetMedicalTriageScriptsError = "GET_MEDICAL_TRIAGE_SCRIPTS_ERROR";
export const ToggleEditCallScriptModal = "TOGGLE_EDIT_CALL_SCRIPT_MODAL";
export const UpdateCallScript = "UPDATE_CALL_SCRIPT";
export const UpdateCallScriptSuccess = "UPDATE_CALL_SCRIPT_SUCCESS";
export const UpdateCallScriptError = "UPDATE_CALL_SCRIPT_ERROR";
export const ToggleEditMedicalTriageScriptModal = "TOGGLE_EDIT_MEDICAL_TRIAGE_SCRIPT_MODAL";
export const UpdateMedicalTriageScript = "UPDATE_MEDICAL_TRIAGE_SCRIPT";
export const UpdateMedicalTriageScriptError = "UPDATE_MEDICAL_TRIAGE_SCRIPT_ERROR";
export const GetMedicalTriageSymptoms = "GET_MEDICAL_TRIAGE_SYMPTOMS";
export const GetMedicalTriageSymptomsSuccess = "GET_MEDICAL_TRIAGE_SYMPTOMS_SUCCESS";
export const GetMedicalTriageSymptomsError = "GET_MEDICAL_TRIAGE_SYMPTOMS_ERROR";
export const ToggleEditMedicalTriageSymptomModal = "TOGGLE_EDIT_MEDICAL_TRIAGE_SYMPTOM_MODAL";
export const UpdateMedicalTriageSymptom = "UPDATE_MEDICAL_TRIAGE_SYMPTOM";
export const UpdateMedicalTriageSymptomSuccess = "UPDATE_MEDICAL_TRIAGE_SYMPTOM_SUCCESS";
export const UpdateMedicalTriageSymptomError = "UPDATE_MEDICAL_TRIAGE_SYMPTOM_ERROR";

// SYSTEM MESSAGES
export const GetMessagesLoginText = "GET_MESSAGES_LOGIN_TEXT";
export const GetMessagesLoginTextSuccess = "GET_MESSAGES_LOGIN_TEXT_SUCCESS";
export const GetMessagesLoginTextError = "GET_MESSAGES_LOGIN_TEXT_ERROR";
export const ToggleLoginMessageModal = "TOGGLE_LOGIN_MESSAGE_MODAL";
export const UpdateMessagesLoginText = "UPDATE_MESSAGES_LOGIN_TEXT";

export const GetMessagesReleaseVersion = "GET_MESSAGES_RELEASE_VERSION";
export const GetMessagesReleaseVersionSuccess = "GET_MESSAGES_RELEASE_VERSION_SUCCESS";
export const GetMessagesReleaseVersionError = "GET_MESSAGES_RELEASE_VERSION_ERROR";
export const ToggleReleaseNoteModal = "TOGGLE_RELEASE_NOTE_MODAL";
export const UpdateReleaseNote = "UPDATE_RELEASE_NOTE";
export const GetReleaseNotesDocument = "GET_RELEASE_NOTES_DOCUMENT";
export const GetReleaseNotesDocumentSuccess = "GET_RELEASE_NOTES_DOCUMENT_SUCCESS";
export const GetReleaseNotesDocumentError = "GET_RELEASE_NOTES_DOCUMENT_ERROR";

// System Tests
export const PostSMSTest = "POST_SMS_TEST";
export const PostSMSTestSuccess = "POST_SMS_TEST_SUCCESS";
export const PostSMSTestError = "POST_SMS_TEST_ERROR";
export const PostEmailTest = "POST_EMAIL_TEST";
export const PostEmailTestSuccess = "POST_EMAIL_TEST_SUCCESS";
export const PostEmailTestError = "POST_EMAIL_TEST_ERROR";

//Clinical Gevernanace
export const ToggleLogNewIncidentModal = "TOGGLE_LOG_NEW_INCIDENT_MODAL";
export const ToggleViewEditIncidentModal = "TOGGLE_VIEW_EDIT_INCIDENT_MODAL";

export const GetClinicalIncidentsRegister = "GET_CLINICAL_INCIDENTS_REGISTER";
export const GetClinicalIncidentsRegisterSuccess = "GET_CLINICAL_INCIDENTS_REGISTER_SUCCESS";
export const GetClinicalIncidentsRegisterError = "GET_CLINICAL_INCIDENTS_REGISTER_ERROR";

export const GetClinicalIncidentsRegisterExport = "GET_CLINICAL_INCIDENTS_REGISTER_EXPORT";
export const GetClinicalIncidentsRegisterExportSuccess =
  "GET_CLINICAL_INCIDENTS_REGISTER_EXPORT_SUCCESS";
export const GetClinicalIncidentsRegisterExportError =
  "GET_CLINICAL_INCIDENTS_REGISTER_EXPORT_ERROR";

export const GetClinicalIncident = "GET_CLINICAL_INCIDENT";
export const GetClinicalIncidentSuccess = "GET_CLINICAL_INCIDENT_SUCCESS";
export const GetClinicalIncidentError = "GET_CLINICAL_INCIDENT_ERROR";

export const DeleteClinicalIncident = "DELETE_CLINICAL_INCIDENT";
export const DeleteClinicalIncidentSuccess = "DELETE_CLINICAL_INCIDENT_SUCCESS";
export const DeleteClinicalIncidentError = "DELETE_CLINICAL_INCIDENT_ERROR";

export const LogNewIncident = "LOG_NEW_INCIDENT";
export const LogNewIncidentSuccess = "LOG_NEW_INCIDENT_SUCCESS";
export const LogNewIncidentError = "LOG_NEW_INCIDENT_ERROR";

export const EditIncident = "EDIT_INCIDENT";
export const EditIncidentSuccess = "EDIT_INCIDENT_SUCCESS";
export const EditIncidentError = "EDIT_INCIDENT_ERROR";

export const GetIncidentTypes = "GET_INCIDENT_TYPES";
export const GetIncidentTypesSuccess = "GET_INCIDENT_TYPES_SUCCESS";
export const GetIncidentTypesError = "GET_INCIDENT_TYPES_ERROR";

export const GetIncidentCauses = "GET_INCIDENT_CAUSES";
export const GetIncidentCausesSuccess = "GET_INCIDENT_CAUSES_SUCCESS";
export const GetIncidentCausesError = "GET_INCIDENT_CAUSES_ERROR";

export const GetCallHandlers = "GET_CALL_HANDLERS";
export const GetCallHandlersSuccess = "GET_CALL_HANDLERS_SUCCESS";
export const GetCallHandlersError = "GET_CALL_HANDLERS_ERROR";

export const GetIncidentRateReportGridData = "GET_INCIDENT_RATE_REPORT_GRID_DATA";
export const GetIncidentRateReportGridDataSuccess = "GET_INCIDENT_RATE_REPORT_GRID_DATA_SUCCESS";
export const GetIncidentRateReportGridDataError = "GET_INCIDENT_RATE_REPORT_GRID_DATA_ERROR";

export const GetIncidentRateReportHeadlines = "GET_INCIDENT_RATE_REPORT_HEADLINES";
export const GetIncidentRateReportHeadlinesSuccess = "GET_INCIDENT_RATE_REPORT_HEADLINES_SUCCESS";
export const GetIncidentRateReportHeadlinesError = "GET_INCIDENT_RATE_REPORT_HEADLINES_ERROR";

export const ExportIncidentRateReport = "EXPORT_INCIDENT_RATE_REPORT";
export const ExportIncidentRateReportSuccess = "EXPORT_INCIDENT_RATE_REPORT_SUCCESS";
export const ExportIncidentRateReportError = "EXPORT_INCIDENT_RATE_REPORT_ERROR";

export const GetServiceDeskSettings = "GET_SERVICE_DESK_SETTINGS";
export const GetServiceDeskSettingsSuccess = "GET_SERVICE_DESK_SETTINGS_SUCCESS";
export const GetServiceDeskSettingsError = "GET_SERVICE_DESK_SETTINGS_ERROR";
export const UpdateServiceDeskSettings = "UPDATE_SERVICE_DESK_SETTINGS";
export const UpdateServiceDeskSettingsSuccess = "UPDATE_SERVICE_DESK_SETTINGS_SUCCESS";
export const UpdateServiceDeskSettingsError = "UPDATE_SERVICE_DESK_SETTINGS_ERROR";

export const GetHealthNotices = "GET_HEALTH_NOTICES";
export const GetHealthNoticesSuccess = "GET_HEALTH_NOTICES_SUCCESS";
export const GetHealthNoticesError = "GET_HEALTH_NOTICES_ERROR";
export const AddHealthNotice = "ADD_HEALTH_NOTICE";
export const AddHealthNoticeSuccess = "ADD_HEALTH_NOTICE_SUCCESS";
export const AddHealthNoticeError = "ADD_HEALTH_NOTICE_ERROR";
export const UpdateHealthNotice = "UPDATE_HEALTH_NOTICE";
export const UpdateHealthNoticeSuccess = "UPDATE_HEALTH_NOTICE_SUCCESS";
export const UpdateHealthNoticeError = "UPDATE_HEALTH_NOTICE_ERROR";
export const GetHealthNotice = "GET_HEALTH_NOTICE";
export const GetHealthNoticeSuccess = "GET_HEALTH_NOTICE_SUCCESS";
export const GetHealthNoticeError = "GET_HEALTH_NOTICE_ERROR";
export const DeleteHealthNotice = "DELETE_HEALTH_NOTICE";
export const DeleteHealthNoticeSuccess = "DELETE_HEALTH_NOTICE_SUCCESS";
export const DeleteHealthNoticeError = "DELETE_HEALTH_NOTICE_ERROR";
export const PublishHealthNotice = "PUBLISH_HEALTH_NOTICE";
export const PublishHealthNoticeSuccess = "PUBLISH_HEALTH_NOTICE_SUCCESS";
export const PublishHealthNoticeError = "PUBLISH_HEALTH_NOTICE_ERROR";
export const CancelHealthNotice = "CANCEL_HEALTH_NOTICE";
export const CancelHealthNoticeSuccess = "CANCEL_HEALTH_NOTICE_SUCCESS";
export const CancelHealthNoticeError = "CANCEL_HEALTH_NOTICE_ERROR";

// IMAGE LIBRARY
export const GetImages = "GET_IMAGES";
export const GetImagesSuccess = "GET_IMAGES_SUCCESS";
export const GetImagesError = "GET_IMAGES_ERROR";
export const UploadImage = "UPLOAD_IMAGE";
export const UploadImageSuccess = "UPLOAD_IMAGE_SUCCESS";
export const UploadImageError = "UPLOAD_IMAGE_ERROR";
export const GetAllergies = "GET_ALLERGIES";
export const GetAllergiesSuccess = "GET_ALLERGIES_SUCCESS";
export const GetAllergiesError = "GET_ALLERGIES_ERROR";
export const AddAllergy = "ADD_ALLERGY";
export const AddAllergySuccess = "ADD_ALLERGY_SUCCESS";
export const AddAllergyError = "ADD_ALLERGY_ERROR";
export const UpdateAllergy = "UPDATE_ALLERGY";
export const UpdateAllergySuccess = "UPDATE_ALLERGY_SUCCESS";
export const UpdateAllergyError = "UPDATE_ALLERGY_ERROR";
export const SetAllergyModal = "SET_ALLERGY_MODAL";

export const GetConditions = "GET_CONDITIONS";
export const GetConditionsSuccess = "GET_CONDITIONS_SUCCESS";
export const GetConditionsError = "GET_CONDITIONS_ERROR";
export const AddCondition = "ADD_CONDITION";
export const AddConditionSuccess = "ADD_CONDITION_SUCCESS";
export const AddConditionError = "ADD_CONDITION_ERROR";
export const UpdateCondition = "UPDATE_CONDITION";
export const UpdateConditionSuccess = "UPDATE_CONDITION_SUCCESS";
export const UpdateConditionError = "UPDATE_CONDITION_ERROR";
export const SetConditionModal = "SET_CONDITION_MODAL";

export const GetMedications = "GET_MEDICATIONS";
export const GetMedicationsSuccess = "GET_MEDICATIONS_SUCCESS";
export const GetMedicationsError = "GET_MEDICATIONS_ERROR";
export const GetMedicationTypes = "GET_MEDICATION_TYPES";
export const GetMedicationTypesSuccess = "GET_MEDICATION_TYPES_SUCCESS";
export const GetMedicationTypesError = "GET_MEDICATION_TYPES_ERROR";
export const AddMedication = "ADD_MEDICATION";
export const AddMedicationSuccess = "ADD_MEDICATION_SUCCESS";
export const AddMedicationError = "ADD_MEDICATION_ERROR";
export const UpdateMedication = "UPDATE_MEDICATION";
export const UpdateMedicationSuccess = "UPDATE_MEDICATION_SUCCESS";
export const UpdateMedicationError = "UPDATE_MEDICATION_ERROR";
export const SetMedicationModal = "SET_MEDICATION_MODAL";

export const GetVaccinations = "GET_VACCINATIONS";
export const GetVaccinationsSuccess = "GET_VACCINATIONS_SUCCESS";
export const GetVaccinationsError = "GET_VACCINATIONS_ERROR";
export const AddVaccination = "ADD_VACCINATION";
export const AddVaccinationSuccess = "ADD_VACCINATION_SUCCESS";
export const AddVaccinationError = "ADD_VACCINATION_ERROR";
export const UpdateVaccination = "UPDATE_VACCINATION";
export const UpdateVaccinationSuccess = "UPDATE_VACCINATION_SUCCESS";
export const UpdateVaccinationError = "UPDATE_VACCINATION_ERROR";
export const SetVaccinationModal = "SET_VACCINATION_MODAL";

export const GetProviders = "GET_PROVIDERS";
export const GetProvidersSuccess = "GET_PROVIDERS_SUCCESS";
export const GetProvidersError = "GET_PROVIDERS_ERROR";
export const AddProvider = "ADD_PROVIDER";
export const AddProviderSuccess = "ADD_PROVIDER_SUCCESS";
export const AddProviderError = "ADD_PROVIDER_ERROR";
export const UpdateProvider = "UPDATE_PROVIDER";
export const UpdateProviderSuccess = "UPDATE_PROVIDER_SUCCESS";
export const UpdateProviderError = "UPDATE_PROVIDER_ERROR";
export const SetProviderModal = "SET_PROVIDER_MODAL";
export const GetProviderLogo = "GET_PROVIDER_LOGO";
export const GetProviderLogoSuccess = "GET_PROVIDER_LOGO_SUCCESS";
export const GetProviderLogoError = "GET_PROVIDER_LOGO_ERROR";

export const GetServiceTypes = "GET_SERVICE_TYPES";
export const GetServiceTypesSuccess = "GET_SERVICE_TYPES_SUCCESS";
export const GetServiceTypesError = "GET_SERVICE_TYPES_ERROR";
export const AddServiceType = "ADD_SERVICE_TYPE";
export const AddServiceTypeSuccess = "ADD_SERVICE_TYPE_SUCCESS";
export const AddServiceTypeError = "ADD_SERVICE_TYPE_ERROR";
export const UpdateServiceType = "UPDATE_SERVICE_TYPE";
export const UpdateServiceTypeSuccess = "UPDATE_SERVICE_TYPE_SUCCESS";
export const UpdateServiceTypeError = "UPDATE_SERVICE_TYPE_ERROR";
export const SetServiceTypeModal = "SET_SERVICE_TYPE_MODAL";
export const GetWellbeingCategories = "GET_WELLBEING_CATEGORIES";
export const GetWellbeingCategoriesSuccess = "GET_WELLBEING_CATEGORIES_SUCCESS";
export const GetWellbeingCategoriesError = "GET_WELLBEING_CATEGORIES_ERROR";
export const GetParentAbsenceReasons = "GET_PARENT_ABSENCE_REASONS";
export const GetParentAbsenceReasonsSuccess = "GET_PARENT_ABSENCE_REASONS_SUCCESS";
export const GetParentAbsenceReasonsError = "GET_PARENT_ABSENCE_REASONS_ERROR";

export const GetCarePlanActivities = "GET_CARE_PLAN_ACTIVITIES";
export const GetCarePlanActivitiesSuccess = "GET_CARE_PLAN_ACTIVITIES_SUCCESS";
export const GetCarePlanActivitiesError = "GET_CARE_PLAN_ACTIVITIES_ERROR";
export const GetCarePlanActivityTypes = "GET_CARE_PLAN_ACTIVITY_TYPES";
export const GetCarePlanActivityTypesSuccess = "GET_CARE_PLAN_ACTIVITY_TYPES_SUCCESS";
export const GetCarePlanActivityTypesError = "GET_CARE_PLAN_ACTIVITY_TYPES_ERROR";
export const GetCarePlanActivityPeriods = "GET_CARE_PLAN_ACTIVITY_PERIODS";
export const GetCarePlanActivityPeriodsSuccess = "GET_CARE_PLAN_ACTIVITY_PERIODS_SUCCESS";
export const GetCarePlanActivityPeriodsError = "GET_CARE_PLAN_ACTIVITY_PERIODS_ERROR";
export const GetCarePlanActivityParents = "GET_CARE_PLAN_ACTIVITY_PARENTS";
export const GetCarePlanActivityParentsSuccess = "GET_CARE_PLAN_ACTIVITY_PARENTS_SUCCESS";
export const GetCarePlanActivityParentsError = "GET_CARE_PLAN_ACTIVITY_PARENTS_ERROR";
export const GetCarePlanActivityCounters = "GET_CARE_PLAN_ACTIVITY_COUNTERS";
export const GetCarePlanActivityCountersSuccess = "GET_CARE_PLAN_ACTIVITY_COUNTERS_SUCCESS";
export const GetCarePlanActivityCountersError = "GET_CARE_PLAN_ACTIVITY_COUNTERS_ERROR";
export const AddCarePlanActivity = "ADD_CARE_PLAN_ACTIVITY";
export const AddCarePlanActivitySuccess = "ADD_CARE_PLAN_ACTIVITY_SUCCESS";
export const AddCarePlanActivityError = "ADD_CARE_PLAN_ACTIVITY_ERROR";
export const UpdateCarePlanActivity = "UPDATE_CARE_PLAN_ACTIVITY";
export const UpdateCarePlanActivitySuccess = "UPDATE_CARE_PLAN_ACTIVITY_SUCCESS";
export const UpdateCarePlanActivityError = "UPDATE_CARE_PLAN_ACTIVITY_ERROR";
export const SetCarePlanActivityModal = "SET_CARE_PLAN_ACTIVITY_MODAL";
export const GetSupportPlanActivities = "GET_SUPPORT_PLAN_ACTIVITIES";
export const GetSupportPlanActivitiesSuccess = "GET_SUPPORT_PLAN_ACTIVITIES_SUCCESS";
export const GetSupportPlanActivitiesError = "GET_SUPPORT_PLAN_ACTIVITIES_ERROR";
export const GetSupportPlanActivityCounters = "GET_SUPPORT_PLAN_ACTIVITY_COUNTERS";
export const GetSupportPlanActivityCountersSuccess = "GET_SUPPORT_PLAN_ACTIVITY_COUNTERS_SUCCESS";
export const GetSupportPlanActivityCountersError = "GET_SUPPORT_PLAN_ACTIVITY_COUNTERS_ERROR";
export const AddSupportPlanActivity = "ADD_SUPPORT_PLAN_ACTIVITY";
export const AddSupportPlanActivitySuccess = "ADD_SUPPORT_PLAN_ACTIVITY_SUCCESS";
export const AddSupportPlanActivityError = "ADD_SUPPORT_PLAN_ACTIVITY_ERROR";
export const UpdateSupportPlanActivity = "UPDATE_SUPPORT_PLAN_ACTIVITY";
export const UpdateSupportPlanActivitySuccess = "UPDATE_SUPPORT_PLAN_ACTIVITY_SUCCESS";
export const UpdateSupportPlanActivityError = "UPDATE_SUPPORT_PLAN_ACTIVITY_ERROR";
export const SetSupportPlanActivityModal = "SET_SUPPORT_PLAN_ACTIVITY_MODAL";
export const GetSupportPlanJobDutyConfigs = "GET_SUPPORT_PLAN_JOB_DUTY_CONFIGS";
export const GetSupportPlanJobDutyConfigsSuccess = "GET_SUPPORT_PLAN_JOB_DUTY_CONFIGS_SUCCESS";
export const GetSupportPlanJobDutyConfigsError = "GET_SUPPORT_PLAN_JOB_DUTY_CONFIGS_ERROR";

export const GetTriageQuestions = "GET_TRIAGE_QUESTIONS";
export const GetTriageQuestionsSuccess = "GET_TRIAGE_QUESTIONS_SUCCESS";
export const GetTriageQuestionsError = "GET_TRIAGE_QUESTIONS_ERROR";
export const GetTriageQuestionSymptoms = "GET_TRIAGE_QUESTION_SYMPTOMS";
export const GetTriageQuestionSymptomsSuccess = "GET_TRIAGE_QUESTION_SYMPTOMS_SUCCESS";
export const GetTriageQuestionSymptomsError = "GET_TRIAGE_QUESTION_SYMPTOMS_ERROR";
export const AddTriageQuestion = "ADD_TRIAGE_QUESTION";
export const AddTriageQuestionSuccess = "ADD_TRIAGE_QUESTION_SUCCESS";
export const AddTriageQuestionError = "ADD_TRIAGE_QUESTION_ERROR";
export const UpdateTriageQuestion = "UPDATE_TRIAGE_QUESTION";
export const UpdateTriageQuestionSuccess = "UPDATE_TRIAGE_QUESTION_SUCCESS";
export const UpdateTriageQuestionError = "UPDATE_TRIAGE_QUESTION_ERROR";
export const SetTriageQuestionModal = "SET_TRIAGE_QUESTION_MODAL";

export const GetTriageAdvices = "GET_TRIAGE_ADVICES";
export const GetTriageAdvicesSuccess = "GET_TRIAGE_ADVICES_SUCCESS";
export const GetTriageAdvicesError = "GET_TRIAGE_ADVICES_ERROR";
export const GetTriageAdviceSymptoms = "GET_TRIAGE_ADVICE_SYMPTOMS";
export const GetTriageAdviceSymptomsSuccess = "GET_TRIAGE_ADVICE_SYMPTOMS_SUCCESS";
export const GetTriageAdviceSymptomsError = "GET_TRIAGE_ADVICE_SYMPTOMS_ERROR";
export const AddTriageAdvice = "ADD_TRIAGE_ADVICE";
export const AddTriageAdviceSuccess = "ADD_TRIAGE_ADVICE_SUCCESS";
export const AddTriageAdviceError = "ADD_TRIAGE_ADVICE_ERROR";
export const UpdateTriageAdvice = "UPDATE_TRIAGE_ADVICE";
export const UpdateTriageAdviceSuccess = "UPDATE_TRIAGE_ADVICE_SUCCESS";
export const UpdateTriageAdviceError = "UPDATE_TRIAGE_ADVICE_ERROR";
export const SetTriageAdviceModal = "SET_TRIAGE_ADVICE_MODAL";
